import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import "../Assets/Styles/home.css";
import Homeslider from '../Components/Home/Homeslider';
import BrandLogoSlider from '../Components/Home/BrandLogoSlider';
import Aboutus from '../Components/Home/Aboutus';
import Footer from '../Components/Home/Footer';
import AIChatButton from '../Components/Home/AIChatButton';
import EnquiryForm from '../Components/EnquiryForm/EnquiryForm';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import ScreenshotPrevention from '../Components/Common/ScreenshotPrevention';
import NewYearAlert from '../Components/Common/NewYearAlert';
import { Helmet } from 'react-helmet';

function Home() {
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup in this session
    const hasSeenPopup = localStorage.getItem('welcomePopupShown');
    
    if (!hasSeenPopup) {
      // Show popup after a delay only if user hasn't seen it before
      const timer = setTimeout(() => {
        setShowWelcomePopup(true);
      }, 3000); // 3 second delay

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClosePopup = () => {
    setShowWelcomePopup(false);
    // Mark that user has seen the popup in this session
    localStorage.setItem('welcomePopupShown', 'true');
  };

  return (
    <>
      <Helmet>
        <title>Trillion Stock Research: SEBI Registered Investment Advisory Firm in Indore</title>
        <meta name="description" content="Trillion Stock Research is a SEBI-registered investment advisory firm (INH000020129) in Indore. Get professional stock market research, investment strategies, and financial guidance. BSE Enlistment No: 6528." />
        <meta name="keywords" content="SEBI registered investment advisor, stock market research Indore, investment advisory services, financial research analyst, Trillion Stock Research, BSE enlisted advisor" />
        <meta name="author" content="Trillion Stock Research" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <link rel="canonical" href="https://www.trillionstockresearch.com/" />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Trillion Stock Research: SEBI Registered Investment Advisory Firm" />
        <meta property="og:description" content="Professional investment advisory services in Indore. SEBI registered research analyst providing stock market research and investment strategies." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.trillionstockresearch.com/" />
        <meta property="og:image" content="https://www.trillionstockresearch.com/fav.png" />
        <meta property="og:site_name" content="Trillion Stock Research" />
        <meta property="og:locale" content="en_IN" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Trillion Stock Research: SEBI Registered Investment Advisory" />
        <meta name="twitter:description" content="Professional investment advisory services in Indore. SEBI registered research analyst." />
        <meta name="twitter:image" content="https://www.trillionstockresearch.com/fav.png" />
        
        {/* Enhanced Schema Markup */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FinancialService",
            "name": "Trillion Stock Research",
            "alternateName": "Trillion Stock Research",
            "url": "https://www.trillionstockresearch.com/",
            "logo": "https://www.trillionstockresearch.com/fav.png",
            "image": "https://www.trillionstockresearch.com/fav.png",
            "description": "SEBI-registered investment advisory firm providing professional stock market research, investment strategies, and financial guidance in Indore, Madhya Pradesh.",
            "foundingDate": "2014",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "200 Sector A Suryadev Nagar",
              "addressLocality": "Indore",
              "addressRegion": "Madhya Pradesh",
              "postalCode": "452012",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "22.7196",
              "longitude": "75.8577"
            },
            "contactPoint": [{
              "@type": "ContactPoint",
              "telephone": "+91 9977555378",
              "contactType": "customer service",
              "areaServed": "IN",
              "availableLanguage": "English, Hindi"
            }],
            "sameAs": [
              "https://www.facebook.com/trillionstockresearch",
              "https://twitter.com/trillionstock"
            ],
            "serviceType": "Investment Advisory",
            "areaServed": {
              "@type": "Country",
              "name": "India"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Investment Advisory Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Stock Market Research",
                    "description": "Comprehensive stock market analysis and research"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Investment Advisory",
                    "description": "Professional investment advice and strategies"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Portfolio Management",
                    "description": "Investment portfolio analysis and management"
                  }
                }
              ]
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.8",
              "reviewCount": "150"
            }
          }
        `}</script>
        
        {/* Local Business Schema */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Trillion Stock Research",
            "image": "https://www.trillionstockresearch.com/fav.png",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "200 Sector A Suryadev Nagar",
              "addressLocality": "Indore",
              "addressRegion": "Madhya Pradesh",
              "postalCode": "452012",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "22.7196",
              "longitude": "75.8577"
            },
            "url": "https://www.trillionstockresearch.com",
            "telephone": "+91 9977555378",
            "priceRange": "₹₹",
            "openingHours": "Mo-Fr 09:00-18:00",
            "currenciesAccepted": "INR",
            "paymentAccepted": "Cash, Credit Card, Bank Transfer"
          }
        `}</script>
      </Helmet>
      <ScreenshotPrevention />
      <NewYearAlert />
      <div>
        {/* <SpaceCanvas /> Removed particles effect */}
        <Homeslider/>
        <BrandLogoSlider />
        
        <section className="sebi-warning">
          <div className="warning-container">
            <div className="warning-icon">⚠️</div>
            <div className="warning-content">
              <p>"Investment in securities market are subject to market risks. Read all the related documents carefully before investing."</p>
            </div>
          </div>
        </section>
        
        <SEBISlider />
        <Aboutus/>
     
      
        
        <section className="important-links-section">
          <div className="links-container">
            <h2>Important Links</h2>
            <div className="links-grid">
              <div className="link-category">
                <h3>Legal & Policies</h3>
                <ul>
                  <li><Link to="/terms">Terms & Conditions</Link></li>
                  <li><Link to="/policy">Privacy Policy</Link></li>
                  <li><Link to="/disclaimer">Disclaimer</Link></li>
                  <li><Link to="/refund">Refund Policy</Link></li>
                  <li><a href="https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&intmId=14" target="_blank" rel="noopener noreferrer">SEBI Verification Link</a></li>
                </ul>
              </div>
              
              <div className="link-category">
                <h3>Services & Information</h3>
                <ul>
                  <li><Link to="/services">Our Services</Link></li>
                  <li><Link to="/pricing">Pricing Plans</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                </ul>
              </div>
              
              <div className="link-category">
                <h3>Compliance & Support</h3>
                <ul>
                  <li><Link to="/complaints">Complaints</Link></li>
                  <li><Link to="/disclosure">SEBI Disclosure</Link></li>
                  <li><Link to="/investor-charter">Investor Charter</Link></li>
                  <li><Link to="/payments">Payment</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        
        {/* <BlogPosts /> */}
        <Footer />
        <AIChatButton />
        <ISOCertificateButton />
        {/* Welcome Popup with Enquiry Form 0*/}
        <EnquiryForm 
          isOpen={showWelcomePopup} 
          onClose={handleClosePopup}
          isWelcomePopup={true}
          prabhujiImage="/Images/prabhuji.jpg"
        />
      </div>
    </>
  );
}

export default Home;

